import { t } from '@lingui/macro';
import * as yup from 'yup';

import { tagInputSchema } from 'components/Form/TagInput/schemaObject';

export const MAX_VINS = 100;

export const schema = yup.object({
  accountId: yup.string().required(t`Account is required`),
  depotId: yup.string().required(t`Depot is required`),
  vins: yup
    .array()
    .of(tagInputSchema)
    .required()
    .min(1, t`At least one VIN is required.`)
    .max(
      MAX_VINS,
      t`VIN limit exceeded. Reduce the number of VINs to continue.`,
    )
    .test('tags-length-17', t`Review the inserted VINs.`, (tags) => {
      const allTagsValid = tags
        .map((tag) => {
          if (typeof tag === 'string') return tag.length === 17;
          if (tag && typeof tag === 'object' && 'text' in tag)
            return tag.text.length === 17;
          return false;
        })
        .every(Boolean);

      return allTagsValid;
    }),
});
